export default {
  create: 'create',
  edit: 'edit',
  reopen: 'reopen'
};
